export default class SecurityManager {
  constructor () {
    this.cryptoSubtle = typeof window.crypto !== 'undefined' ? window.crypto.subtle || window.crypto.webkitSubtle : null
    this.textDecoder = typeof TextDecoder !== 'undefined' ? new TextDecoder('utf-8') : null
    this.textEncoder = typeof TextEncoder !== 'undefined' ? new TextEncoder('utf-8') : null

    this.salt = 'aaaabbbbccccdddd This is NOT secret!!'
    this.passphraseAlgorithm = {
      name: 'PBKDF2'
    }
    this.keyAlgorithm = {
      name: 'PBKDF2',
      hash: 'SHA-512',
      iterations: 1000,
      salt: this.textEncoder ? this.textEncoder.encode(this.salt) : null
    }
    this.encryptionAlgorithm = {
      name: 'AES-CBC',
      length: 256
    }
    this.decryptionAlgorithm = {
      name: 'AES-CBC'
    }
    this.iv = null
    this.key = null
  }
  
  setDataKey (passphrase) {
    return new Promise((resolve, reject) => {
      this.passphraseKey(passphrase).then((passphraseKey) => {
        this.encryptionKey(passphraseKey).then((dataKey) => {
          this.key = dataKey
          resolve()
        }, reject).catch(reject)
      }, reject).catch(reject)
    })
  }

  passphraseKey (passphrase) {
    return this.cryptoSubtle.importKey(
      'raw',
      this.textEncoder.encode(passphrase),
      this.passphraseAlgorithm,
      false,
      ['deriveKey']
    )
  }

  encryptionKey (key) {
    return this.cryptoSubtle.deriveKey(
      this.keyAlgorithm,
      key,
      this.encryptionAlgorithm,
      true,
      ['encrypt', 'decrypt']
    )
  }

  encryptData (data) {
    this.iv = new Uint8Array(16)
    window.crypto.getRandomValues(this.iv)

    return new Promise((resolve, reject) => {
      this.encrypt(this.textEncoder.encode(data), this.key, this.iv).then((encryptedData) => {
        let result = new Uint8Array(this.iv.byteLength + encryptedData.byteLength)
        result.set(this.iv, 0)
        result.set(new Uint8Array(encryptedData), this.iv.byteLength)
        resolve(result)
      }, reject).catch(reject)
    })
  }

  decryptData (data) {
    return new Promise((resolve, reject) => {
      this.iv = data.slice(0, 16)
      let encryptedData = data.slice(16)

      if (encryptedData.byteLength > 0) {
        this.decrypt(encryptedData, this.key, this.iv).then((decryptedData) => {
          resolve(this.textDecoder.decode(decryptedData))
        }, reject).catch(reject)
      } else {
        resolve(null)
      }
    })
  }

  encrypt (data, key, iv) {
    let algorithm = Object.assign({}, this.encryptionAlgorithm)
    algorithm.iv = iv

    return this.cryptoSubtle.encrypt(
      algorithm,
      key,
      data
    )
  }

  decrypt (data, key, iv) {
    let algorithm = Object.assign({}, this.decryptionAlgorithm)
    algorithm.iv = iv

    return this.cryptoSubtle.decrypt(
      algorithm,
      key,
      data
    )
  }
}




// WEBPACK FOOTER //
// ./js/lib/SecurityManager.js